import * as ActivityTeamEducation from './activityTeamEducation.js';
export default ActivityTeamEducation;
